export var freqBands = ['250','500','1000','2000','4000','8000'];

export default {freqBands};